export default {
  extractLangFromLocale: (locale) => {
    return locale.substring(0, 2);
  },
};



// WEBPACK FOOTER //
// ./src/utils/LocaleUtils.js